import axios from 'axios';

function getReleaseList (clientId) {
  return axios.get('api/releaselist/' + clientId);
}

function lastReleaselist () {
  return axios.get('api/lastReleaselist/');
}

function saveNewRelease (newUsers) {
  return axios.post('api/release', {newRelease: newUsers});
}

function deleteRelease (releaseIdToDelete) {
  return axios.get('api/releaseDelete/' + releaseIdToDelete);
}

function updateUser (user) {
  return axios.put('api/users', {user: user});
}

function getReleaseDetail (releaseIdToDetail) {
  return axios.get('api/releasedetail/' + releaseIdToDetail);
}

function updateNewRelease (newData) {
  return axios.post('api/releaseupdate', {newData: newData});
}

export {
  getReleaseList,
  saveNewRelease,
  deleteRelease,
  updateUser,
  getReleaseDetail,
  updateNewRelease,
  lastReleaselist
};



// WEBPACK FOOTER //
// ./src/services/ReleaseService.js